import Box from '@mui/material/Box';
import { useAppSelector } from 'src/store';

const Standalone = ({ children }: any) => {
  const user = useAppSelector(state => state.user.user);
  console.log(user);
  //return children;
  return user !== undefined ? (
    children
  ) : (
    <Box pr={2} sx={{ padding: '16px 16px 16px 241px' }}>
      <h1>The app is not available in Standalone mode.</h1>
    </Box>
  );
};

export default Standalone;
